import {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";

import {useLevelV2} from "~/api/hooks/useLevelV2";
import {useGame} from "~/contexts/game-manager/GameManagerProvider";
import useLevelLoader from "~/contexts/loader/useLevelLoader";

const useLoadCurrentLevel = () => {
  const navigate = useNavigate();
  const {id} = useParams<{id: string}>();

  const {gameManager} = useGame();

  const {data: level, isError} = useLevelV2({id});

  const load = useLevelLoader();

  // Navigate back if level loading results in an error.
  useEffect(() => {
    if (isError) {
      navigate("/play");
    }
  }, [isError, navigate]);

  useEffect(() => {
    if (!id || !level) {
      return;
    }

    // Initial load / level change
    load(id, level);

    if (!gameManager) {
      return;
    }

    const handleRoundStarted = () => {
      load(id, level, true);
    };

    gameManager.on("round-started", handleRoundStarted);

    return () => {
      gameManager.off("round-started", handleRoundStarted);
    };
  }, [gameManager, id, level, load]);
};

export default useLoadCurrentLevel;
